import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from "@angular/core";

@Component({
    selector: "app-cerrix-color-box",
    imports: [],
    templateUrl: "./cerrix-color-box.component.html",
    styleUrl: "./cerrix-color-box.component.scss",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CerrixColorBoxComponent {
    @Input() color?: string;
}
